import { useTranslation } from 'react-i18next';

import { resolveAssetUrl } from '@speeki/frontend-utils';

import iconNoResults from '@shared/svgs/IconNoResults.svg';

import {
    Description,
    EmptySearchListWrapper,
    Title,
} from './EmptySearchList.styled';

export const EmptySearchList = () => {
    const { t } = useTranslation();

    return (
        <EmptySearchListWrapper>
            <img alt="No results" src={resolveAssetUrl(iconNoResults)} />
            <Title>{t('NO_RESULTS')}</Title>
            <Description>{t('NO_RESULTS_DESCRIPTION')}</Description>
        </EmptySearchListWrapper>
    );
};
